"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Grid = _interopRequireDefault(require("@mui/material/Unstable_Grid2/Grid2"));
var _bfBaseStyles = require("@bestfit-team/bf-base-styles");
var _system = require("@mui/system");
var _excluded = ["children"];
var _templateObject;
var GridTwoStyles = (0, _styledComponents.default)(_system.Box)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  padding-bottom: ", "; \n  padding-top: ", "; \n  background-image: url(", ");\n  background-color: ", ";\n  \n  @media (min-width: ", ") {\n    padding-bottom: ", "; \n    padding-top: ", "; \n  }\n"])), function (props) {
  return props.marginless ? 0 : '32.5px';
}, function (props) {
  return props.marginless ? 0 : '32.5px';
}, function (props) {
  return props.backgroundImageUrl;
}, function (props) {
  return props.heroBackgroundColor;
}, _bfBaseStyles.Breakpoints.m, function (props) {
  return props.marginless ? 0 : '75px';
}, function (props) {
  return props.marginless ? 0 : '75px';
});
var GridTwo = function GridTwo(_ref) {
  var children = _ref.children,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return _react.default.createElement(GridTwoStyles, props, _react.default.createElement(_Grid.default, Object.assign({
    container: true,
    maxWidth: props.spansFullPage === true ? false : props.customWidth ? props.customWidth : 'lg',
    disableGutters: props.spansFullPage === true
  }, props), children));
};
var _default = GridTwo;
exports.default = _default;